
function initCartDiscountForm() {
  const discountCodeForms = document.querySelectorAll('#cart-discount-form');
  const normalize = (s) => (s ?? '').trim().toLowerCase();

  discountCodeForms.forEach((form) => {
    // Prevent double initialization
    if (form.dataset.discountInit === 'true') return;
    form.dataset.discountInit = 'true';

    const applyBtn = form.querySelector('#apply-discount-btn');
    if (applyBtn) applyBtn.disabled = false;
    /* ─────────────── DOM refs ─────────────── */
    const discountCodeInput   = form.parentNode.querySelector('#discount-code-input');
    const discountCodeSuccess = form.parentNode.querySelector('#discount-code-success');
    const discountCodeError   = form.parentNode.querySelector('#discount-code-error');

    /* ─────────────── UI helpers ─────────────── */
    const hideMessages = () => {
      if (discountCodeSuccess) discountCodeSuccess.style.display = 'none';
      if (discountCodeError)   discountCodeError.style.display   = 'none';
    };
    const showError   = (m) =>
      discountCodeError &&
      (discountCodeError.textContent = m,
       discountCodeError.style.display = 'block',
       setTimeout(() => (discountCodeError.style.display = 'none'), 2000));
    const showSuccess = (m) =>
      discountCodeSuccess &&
      (discountCodeSuccess.textContent = m,
       discountCodeSuccess.style.display = 'block');

    /* ─────────── verify discount helper ─────────── */
    const checkForDiscount = (cart, rawCode) => {
      const codeNorm = normalize(rawCode);
      return (
        cart.cart_level_discount_applications?.some(
          (d) => normalize(d.code || d.title) === codeNorm
        ) ||
        cart.items?.some((item) =>
          item.discounts?.some(
            (disc) => normalize(disc.code || disc.title) === codeNorm
          )
        )
      );
    };

    /* ─────────── unified, async submit ─────────── */
    form.onsubmit = async (e) => {
      e.preventDefault();
      hideMessages();

      const rawCode = discountCodeInput?.value ?? '';
      const trimmed = rawCode.trim();
      if (!trimmed) return showError('Enter a discount code');

      const codeForURL = encodeURIComponent(trimmed.toUpperCase()); // force uppercase
      showSuccess('Checking Discount…');

      try {
        // 1️⃣ apply discount silently
        await fetch(`/discount/${codeForURL}?redirect=/cart`);

        // 2️⃣ confirm it stuck
        const cartRes = await fetch('/cart.js');
        const cart    = await cartRes.json();

        if (checkForDiscount(cart, trimmed)) {
          showSuccess('Discount applied! Updating Cart…');
          setTimeout(() => window.location.href = '/cart', 2500); // redirect to cart page
        } else {
          discountCodeSuccess.style.display = 'none'
          showError('This code is invalid, has expired, or cannot be combined with current promotions.');
        }
      } catch (err) {
        console.error(err);
        showError('Something went wrong applying the code');
      }
    };
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCartDiscountForm();

  // The discount form is destroyed and re-created whenever the cart re-renders
  // (add to cart, quantity change, bundle removal, etc.). Every one of those
  // paths replaces the innerHTML of a container *inside* the cart drawer or the
  // main cart footer — both of which are themselves stable and never replaced.
  //
  // The previous implementation observed the whole `document` and never
  // disconnected, so it fired for every third-party script insertion on every
  // page. Scope the observation to those stable cart containers instead: the
  // observer now only wakes on cart-subtree mutations (i.e. exactly when the
  // form is re-created), and `initCartDiscountForm` is idempotent (it guards on
  // `dataset.discountInit`), so re-binding on each mutation is cheap.
  const observeCartContainer = (container) => {
    if (!container || container.dataset.discountObserved === 'true') return;
    container.dataset.discountObserved = 'true';

    const observer = new MutationObserver(() => {
      // Re-bind only if a (possibly re-created) form is present in this subtree.
      if (container.querySelector('#cart-discount-form')) {
        initCartDiscountForm();
      }
    });
    observer.observe(container, { childList: true, subtree: true });
  };

  // `cart-drawer` is present on every page; `main-cart-footer` only on the cart
  // page. Guard: pages with neither container never set up an observer.
  observeCartContainer(document.querySelector('cart-drawer'));
  observeCartContainer(document.getElementById('main-cart-footer'));
});

document.addEventListener('DOMContentLoaded', () => {
  // Remove discount button
  document.addEventListener('click', async (e) => {
    if (!e.target.matches('.remove-discount-btn')) return;
    e.preventDefault();

    const btn = e.target;
    btn.disabled = true;
    btn.textContent = 'Removing…';

    try {
      // remove discount via AJAX
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' }) // remove all discount codes
      });

      // Reload cart page or AJAX drawer
      if (window.renderCart) {
        // AJAX drawer present → update dynamically
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        window.renderCart(cart); // update drawer content
      } else {
        // Otherwise, full page cart reload
        window.location.href = '/cart';
      }
    } catch (err) {
      console.error('Error removing discount:', err);
      alert('Failed to remove discount. Please try again.');
    } 
  });
});